export default function Footer(props) {
  return (
    <div className=" bg-gray-50 text-gray-900">
      <div className="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
        <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
          <img className="h-10 w-auto" src="/logo-b.png" alt="logo" />
        </div>
        <div className="mt-4 lg:row-span-3 lg:mt-0 ">
          <p className="text-3xl tracking-tight ">Contact Me</p>
          <div className="flex items-center">
            <div className="flex items-center">{props.email}</div>
          </div>
        </div>
        <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pb-6 lg:pr-8 lg:pt-6">
          <h2 className="text-sm font-medium">
            포트폴리오를 검토해 주셔서 감사합니다.
          </h2>
          <div className="mt-4 space-y-6">
            <p className="text-sm text-gray-600">{props.desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
